export * from './acquisitionAndReactivationReprocess';
export * from './activeFormAdmin';
export * from './activeSubscriptionNew';
export * from './address';
export * from './allSubscriptionTypes';
export * from './anualMonthlyPaymentConfig';
export * from './anualMonthlyPaymentConfigUpdateRequest';
export * from './article';
export * from './articleAccessDetail';
export * from './articleDetail';
export * from './articleLikeDetail';
export * from './articleType';
export * from './attribute';
export * from './attributeCreateRequest';
export * from './attributeGroup';
export * from './attributeGroupCreateRequest';
export * from './attributeGroupUpdateRequest';
export * from './attributeOption';
export * from './attributeOptionCreateRequest';
export * from './attributeOptionUpdateRequest';
export * from './attributeUpdateRequest';
export * from './badge';
export * from './badgeActionType';
export * from './badgeDTO';
export * from './badgeRequest';
export * from './badgeRule';
export * from './badgeRuleDetailed';
export * from './badgeRuleRequest';
export * from './basicinfoBatchBody';
export * from './beautyProfileAttribute';
export * from './benefitWithoutCard';
export * from './benefitWithoutCoupon';
export * from './benefitWithoutNextMonth';
export * from './bfluenceProblemGroupDetail';
export * from './blacklistedCpf';
export * from './blacklistedCpfRequest';
export * from './blacklistedDomain';
export * from './blacklistedDomainRequest';
export * from './brand';
export * from './brandCreateRequest';
export * from './brandProductVariantMovementTags';
export * from './brandSummaryView';
export * from './brandUpdateRequest';
export * from './campaign';
export * from './campaignEligibleCustomerDTO';
export * from './campaignExecutionCustomer';
export * from './campaignGenerateRequest';
export * from './campaignGift';
export * from './campaignGiftItemRequest';
export * from './campaignGiftRequest';
export * from './campaignHistorySummaryDTO';
export * from './campaignProductValidationDTO';
export * from './campaignProductValidationRequest';
export * from './campaignRequest';
export * from './campaignSubscriptionType';
export * from './campaignSubscriptionTypeRequest';
export * from './canceledWithPendingBilling';
export * from './cardDifference';
export * from './cardOtherSubscription';
export * from './categoriesBatchBody';
export * from './category';
export * from './categorySummaryDTO';
export * from './cepLookupExistsResponse';
export * from './cepLookupUpsertRequest';
export * from './cepLookupUpsertResponse';
export * from './composition';
export * from './compositionBeautyProfileCheck';
export * from './compositionCheckRequest';
export * from './compositionDetails';
export * from './compositionEditionStatusTotal';
export * from './compositionProduct';
export * from './compositionProductVariant';
export * from './compositionProductVariantSummary';
export * from './compositionProductVariantSummaryDTO';
export * from './compositionProduction';
export * from './compositionProductionCreateRequest';
export * from './compositionProductionSummary';
export * from './compositionSubscriberEditionStatusCounter';
export * from './compositionSubscribersToRemoveRequest';
export * from './coupon';
export * from './couponAcquisitionSummary';
export * from './couponCreateRequest';
export * from './couponDTO';
export * from './couponEmailRestriction';
export * from './couponEmailRestrictionDetail';
export * from './couponEmailRestrictionUpdateRequest';
export * from './couponEmailsRestrictionUpdateRequest';
export * from './couponEnabledUpdateRequest';
export * from './couponPriceChange';
export * from './couponPriceChangeDetail';
export * from './couponPriceChangeDto';
export * from './couponProductChangeDetail';
export * from './couponProductChangeDto';
export * from './couponProductVariant';
export * from './couponProductVariantCreateRequest';
export * from './couponProductVariantGroupRestriction';
export * from './couponProductVariantSubscriptionTypeRestriction';
export * from './couponProductVariantSubscriptionTypeRestrictionChange';
export * from './couponProductVariantSummary';
export * from './couponSubscriptionTypeRestriction';
export * from './couponSubscriptionTypeRestrictionChange';
export * from './couponSummary';
export * from './couponUpdateRequest';
export * from './couponUsageSummary';
export * from './couponUsageType';
export * from './couponUsageTypeByCouponName';
export * from './course';
export * from './courseCreateRequest';
export * from './courseDetail';
export * from './courseLikeDetail';
export * from './courseModule';
export * from './courseModuleContent';
export * from './courseModuleContentAccessDetail';
export * from './courseModuleContentCreateRequest';
export * from './courseModuleCreateRequest';
export * from './courseUpdateRequest';
export * from './createdTransactionBenefit';
export * from './creditCard';
export * from './creditCardPayment';
export * from './creditCardPaymentSummary';
export * from './creditCardRecurrenceLogDetail';
export * from './creditCardRecurrenceStatus';
export * from './creditCardSummary';
export * from './customQuery';
export * from './customQueryDetail';
export * from './customQueryGroup';
export * from './dailyOrderCountByMonth';
export * from './deadlockedBenefit';
export * from './disableCreditCardRecurrenceRequest';
export * from './divergentBfluencerStatus';
export * from './divergentBfluencerStatusCheck';
export * from './divergentSubscriberBenefit';
export * from './dontReceiveGift';
export * from './doubleCommission';
export * from './dropdownFilter';
export * from './duplicatedEdition';
export * from './duplicatedReward';
export * from './ebookTaxPriceDto';
export * from './edition';
export * from './editionBadgeScoreDetails';
export * from './editionCustomization';
export * from './editionCustomizationIconRequest';
export * from './editionCustomizationIcons';
export * from './editionCustomizationRequest';
export * from './editionScoreDetails';
export * from './editionScoreLogAcc';
export * from './emailNotification';
export * from './emailNotificationBasicDetail';
export * from './emailNotificationDetail';
export * from './emailNotificationRequest';
export * from './emailTemplate';
export * from './emailTemplateRequest';
export * from './emailTemplateResponse';
export * from './emailrestrictionsCouponIdBody';
export * from './expiredGlampoints';
export * from './exportedOrderTotal';
export * from './failedPaymentData';
export * from './feedbackAnswer';
export * from './feedbackAnswerDetail';
export * from './feedbackCrossingFilterRequest';
export * from './feedbackForm';
export * from './feedbackFormCloneRequest';
export * from './feedbackFormCreateRequest';
export * from './feedbackFormCrossingRequest';
export * from './feedbackFormDetail';
export * from './feedbackFormQuestionsResponse';
export * from './feedbackFormUpdateRequest';
export * from './feedbackGroup';
export * from './feedbackGroupCreateRequest';
export * from './feedbackGroupDetail';
export * from './feedbackGroupOption';
export * from './feedbackGroupUpdateRequest';
export * from './feedbackLLMResponse';
export * from './feedbackOption';
export * from './feedbackOptionCreateRequest';
export * from './feedbackOptionUpdateRequest';
export * from './feedbackQuestion';
export * from './feedbackQuestionCreateRequest';
export * from './feedbackQuestionGroup';
export * from './feedbackQuestionGroupUpdateRequest';
export * from './feedbackQuestionUpdateRequest';
export * from './feedbackQuestionsCloneRequest';
export * from './feedbackadminUploadBody';
export * from './fileCompressBody';
export * from './fileUploadBody';
export * from './gCPDatabaseUserCreateRequest';
export * from './gCPDatabaseUserPasswordRequest';
export * from './gCPDatabaseUserPermissionsRequest';
export * from './gCPDatabaseUserResponse';
export * from './gateway';
export * from './genericProductCategory';
export * from './giftCycleItemDTO';
export * from './giftCycleItemRequest';
export * from './giftCycleRequest';
export * from './giftCycleResponseDTO';
export * from './glamclubUploadBody';
export * from './group';
export * from './incorrectAnnualMonthInstallment';
export * from './incorrectEndEdition';
export * from './incorrectPendingBilling';
export * from './incorrectSubscriberStatus';
export * from './influencer';
export * from './influencerCoupon';
export * from './influencerCouponDetailView';
export * from './influencerCouponRequest';
export * from './influencerCouponUpdateRequest';
export * from './influencerDetail';
export * from './influencerStatus';
export * from './influencerTransactionType';
export * from './influencerUpdateRequest';
export * from './infolessAddress';
export * from './instagramUser';
export * from './integrationToken';
export * from './integrationTokenDomain';
export * from './integrationTokenDomainView';
export * from './integrationTokenRole';
export * from './integrationTokenView';
export * from './integrity';
export * from './integrityCategory';
export * from './integrityCategoryDTO';
export * from './integrityCreateDTO';
export * from './integrityHistoryDTO';
export * from './invoiceControl';
export * from './itauAtivacaoRecorrenciaResponse';
export * from './itauAtualizacaoCobrancaRecorrente';
export * from './itauAtualizacaoRecorrencia';
export * from './itauCalendarioRecorrencia';
export * from './itauCancelamentoRecorrencia';
export * from './itauCobrancaCalendarioResponse';
export * from './itauCobrancaDevedor';
export * from './itauCobrancaInfoAdicional';
export * from './itauCobrancaPixDevolucao';
export * from './itauCobrancaPixDevolucaoHorario';
export * from './itauCobrancaPixResponse';
export * from './itauCobrancaRecorrenteCalendario';
export * from './itauCobrancaRecorrenteResponse';
export * from './itauCobrancaResponse';
export * from './itauDadosJornadaAtivacao';
export * from './itauDadosQRCode';
export * from './itauDevedorCobrancaRecorrente';
export * from './itauDevedorRecorrencia';
export * from './itauEncerramentoRecorrencia';
export * from './itauLocCobranca';
export * from './itauRecebedorCobrancaRecorrente';
export * from './itauRecebedorResponse';
export * from './itauRecorrenciaResponse';
export * from './itauRejeicaoResponse';
export * from './itauTentativaCobrancaRecorrente';
export * from './itauValorCobranca';
export * from './itauValorRecorrencia';
export * from './itauVinculoRecorrencia';
export * from './itauWebhookResponse';
export * from './itauWebhookUpdateRequest';
export * from './live';
export * from './liveAccessDetail';
export * from './liveContent';
export * from './liveContentRequest';
export * from './liveCreateRequest';
export * from './liveDetail';
export * from './liveLikeDetail';
export * from './liveUpdateRequest';
export * from './loggerUpdatedServiceCompanyRangeDTO';
export * from './loggerUpdatedShippingCompanyRangeDTO';
export * from './modifyReviewsRequest';
export * from './muchPendingBillings';
export * from './notAttemptedPayment';
export * from './notPendingRecurrence';
export * from './notificationTrend';
export * from './notificationTrendRequest';
export * from './nullAddress';
export * from './option';
export * from './orders';
export * from './ordersItemsDetailDTO';
export * from './orphanSchedulerJobResponse';
export * from './pagarMeAddressResponse';
export * from './pagarMeCustomerResponse';
export * from './pagarMePhone';
export * from './pagarMeTransactionResponsePhoneObject';
export * from './pageAcquisitionAndReactivationReprocess';
export * from './pageActiveFormAdmin';
export * from './pageActiveSubscriptionNew';
export * from './pageAllSubscriptionTypes';
export * from './pageArticleDetail';
export * from './pageBadge';
export * from './pageBenefitWithoutCard';
export * from './pageBenefitWithoutCoupon';
export * from './pageBenefitWithoutNextMonth';
export * from './pageBrandSummaryView';
export * from './pageCanceledWithPendingBilling';
export * from './pageCardDifference';
export * from './pageCardOtherSubscription';
export * from './pageCompositionDetails';
export * from './pageCompositionProductionSummary';
export * from './pageCouponPriceChangeDetail';
export * from './pageCouponSummary';
export * from './pageCourseDetail';
export * from './pageCreatedTransactionBenefit';
export * from './pageCreditCardPaymentSummary';
export * from './pageCreditCardRecurrenceLogDetail';
export * from './pageCustomQueryDetail';
export * from './pageDeadlockedBenefit';
export * from './pageDivergentBfluencerStatusCheck';
export * from './pageDivergentSubscriberBenefit';
export * from './pageDontReceiveGift';
export * from './pageDoubleCommission';
export * from './pageDuplicatedReward';
export * from './pageEditionCustomization';
export * from './pageEmailNotificationBasicDetail';
export * from './pageEmailNotificationDetail';
export * from './pageEmailTemplate';
export * from './pageExpiredGlampoints';
export * from './pageFailedPaymentData';
export * from './pageFeedbackAnswerDetail';
export * from './pageFeedbackFormDetail';
export * from './pageFeedbackGroupDetail';
export * from './pageIncorrectAnnualMonthInstallment';
export * from './pageIncorrectEndEdition';
export * from './pageIncorrectPendingBilling';
export * from './pageIncorrectSubscriberStatus';
export * from './pageInfolessAddress';
export * from './pageIntegrationTokenView';
export * from './pageLiveDetail';
export * from './pageMuchPendingBillings';
export * from './pageNotAttemptedPayment';
export * from './pageNotPendingRecurrence';
export * from './pageNullAddress';
export * from './pagePaidBillingsSameMonth';
export * from './pagePaymentErrorDetail';
export * from './pagePaymentResponseMessageDetail';
export * from './pagePaymentSameMonth';
export * from './pagePaymentWithoutBilling';
export * from './pagePendingWithoutRecurrence';
export * from './pagePersonDetail';
export * from './pagePersonLogTransaction';
export * from './pageProductFeedbackAdmin';
export * from './pageProductReviewDetailed';
export * from './pageProductSummary';
export * from './pageProductVariantCategoryDetail';
export * from './pageProductVariantShippingOrderDetail';
export * from './pageRecurrenceIsNull';
export * from './pageRenewalReprocess';
export * from './pageRenewalWrongPrice';
export * from './pageSQLSession';
export * from './pageShippingOrderDetail';
export * from './pageShippingOrderRequestDetail';
export * from './pageShopOrderRequest';
export * from './pageSubscriberCancellationDetail';
export * from './pageSubscriberCouponSummary';
export * from './pageSubscriberInfo';
export * from './pageSubscriberLogDetail';
export * from './pageSubscriberPaymentStepError';
export * from './pageSubscriberRefundSummary';
export * from './pageSubscriberRenewalRefund';
export * from './pageTwoSubscriptionsInOneCpf';
export * from './pageUncomputedBfluenceTransactionCheck';
export * from './pageUnregisteredSubCommission';
export * from './pageWrongRecurrenceDate';
export * from './pageableFilter';
export * from './pageableObject';
export * from './pageableRequest';
export * from './paidBillingsSameMonth';
export * from './passwordResetRequest';
export * from './passwordResetResponse';
export * from './passwordUpdateRequest';
export * from './paymentDivergentPlan';
export * from './paymentErrorDetail';
export * from './paymentExpirationConfig';
export * from './paymentExpirationConfigLogDetail';
export * from './paymentExpirationConfigUpdateRequest';
export * from './paymentResponseMessage';
export * from './paymentResponseMessageDetail';
export * from './paymentResponseMessageRequest';
export * from './paymentResponseMessageType';
export * from './paymentRound';
export * from './paymentRoundCreditCardPayment';
export * from './paymentRoundListResponse';
export * from './paymentRoundRunningStatus';
export * from './paymentRoundSummary';
export * from './paymentRoundUpsertRequest';
export * from './paymentSameMonth';
export * from './paymentWithoutBilling';
export * from './pendingExportOrder';
export * from './pendingWithoutRecurrence';
export * from './periodType';
export * from './person';
export * from './personActionCreateRequest';
export * from './personActionDetailed';
export * from './personAttributeLogDetail';
export * from './personDetail';
export * from './personFeedbackGroupDetail';
export * from './personLogTransaction';
export * from './personRelationInfo';
export * from './personReward';
export * from './personType';
export * from './personUpdateRequest';
export * from './pixPaymentAttempt';
export * from './pixPaymentReport';
export * from './pixRecurrenceDetail';
export * from './product';
export * from './productCategoryCreateRequest';
export * from './productCategoryUpdateRequest';
export * from './productCreateRequest';
export * from './productFeedbackAdmin';
export * from './productFinality';
export * from './productFinalityItem';
export * from './productImage';
export * from './productImageProductVariantUpdateRequest';
export * from './productImageRequest';
export * from './productInfoDTO';
export * from './productIntegrationFailure';
export * from './productReviewDetailed';
export * from './productReviewId';
export * from './productSearchResponse';
export * from './productSummary';
export * from './productUpdateRequest';
export * from './productVariant';
export * from './productVariantAttribute';
export * from './productVariantBrand';
export * from './productVariantCategoryDetail';
export * from './productVariantCategoryDetailResponse';
export * from './productVariantCreateRequest';
export * from './productVariantDTO';
export * from './productVariantFidelizationSummary';
export * from './productVariantReserved';
export * from './productVariantShippingOrderDetail';
export * from './productVariantSummary';
export * from './productVariantTotals';
export * from './productVariantTotalsByDate';
export * from './productVariantUpdateRequest';
export * from './recurrenceIsNull';
export * from './renewalReprocess';
export * from './renewalWrongPrice';
export * from './resendDashboardCount';
export * from './resendStatusCount';
export * from './resolutionResult';
export * from './responseB4AAddress';
export * from './responseB4AAnualMonthlyPaymentConfig';
export * from './responseB4AArticle';
export * from './responseB4AAttribute';
export * from './responseB4AAttributeGroup';
export * from './responseB4AAttributeOption';
export * from './responseB4ABadge';
export * from './responseB4ABadgeRule';
export * from './responseB4ABadgeRuleDetailed';
export * from './responseB4ABeautyProfile';
export * from './responseB4ABlacklistedCpf';
export * from './responseB4ABlacklistedDomain';
export * from './responseB4ABoolean';
export * from './responseB4ABrand';
export * from './responseB4ACampaign';
export * from './responseB4ACampaignHistorySummaryDTO';
export * from './responseB4ACampaignProductValidationDTO';
export * from './responseB4ACategory';
export * from './responseB4ACepLookupExistsResponse';
export * from './responseB4ACepLookupUpsertResponse';
export * from './responseB4AComposition';
export * from './responseB4ACompositionProduct';
export * from './responseB4ACompositionProduction';
export * from './responseB4ACompositionProductionSummary';
export * from './responseB4ACompositionSubscriberEditionStatusCounter';
export * from './responseB4ACoupon';
export * from './responseB4ACouponEmailRestriction';
export * from './responseB4ACouponPriceChange';
export * from './responseB4ACouponProductVariant';
export * from './responseB4ACourse';
export * from './responseB4ACourseModule';
export * from './responseB4ACourseModuleContent';
export * from './responseB4ACreditCard';
export * from './responseB4ACreditCardPayment';
export * from './responseB4ACreditCardPaymentSummary';
export * from './responseB4ACustomQuery';
export * from './responseB4AEditionCustomization';
export * from './responseB4AEditionScoreDetails';
export * from './responseB4AEmailNotification';
export * from './responseB4AEmailTemplateResponse';
export * from './responseB4AExportedOrderTotal';
export * from './responseB4AFeedbackForm';
export * from './responseB4AFeedbackFormQuestionsResponse';
export * from './responseB4AFeedbackGroup';
export * from './responseB4AFeedbackOption';
export * from './responseB4AFeedbackQuestion';
export * from './responseB4AFeedbackQuestionGroup';
export * from './responseB4AGCPDatabaseUserResponse';
export * from './responseB4AGiftCycleResponseDTO';
export * from './responseB4AInfluencer';
export * from './responseB4AInfluencerCoupon';
export * from './responseB4AInfluencerDetail';
export * from './responseB4AInstagramUser';
export * from './responseB4AInteger';
export * from './responseB4AIntegrationToken';
export * from './responseB4AIntegrationTokenDomain';
export * from './responseB4AItauCobrancaRecorrenteResponse';
export * from './responseB4AItauCobrancaResponse';
export * from './responseB4AItauRecorrenciaResponse';
export * from './responseB4AItauWebhookResponse';
export * from './responseB4AListAcquisitionAndReactivationReprocess';
export * from './responseB4AListActiveSubscriptionNew';
export * from './responseB4AListAddress';
export * from './responseB4AListAnualMonthlyPaymentConfig';
export * from './responseB4AListArticle';
export * from './responseB4AListArticleAccessDetail';
export * from './responseB4AListArticleLikeDetail';
export * from './responseB4AListArticleType';
export * from './responseB4AListAttribute';
export * from './responseB4AListAttributeGroup';
export * from './responseB4AListAttributeOption';
export * from './responseB4AListBadgeActionType';
export * from './responseB4AListBadgeDTO';
export * from './responseB4AListBadgeRule';
export * from './responseB4AListBadgeRuleDetailed';
export * from './responseB4AListBenefitWithoutCard';
export * from './responseB4AListBenefitWithoutCoupon';
export * from './responseB4AListBenefitWithoutNextMonth';
export * from './responseB4AListBfluenceProblemGroupDetail';
export * from './responseB4AListBlacklistedCpf';
export * from './responseB4AListBlacklistedDomain';
export * from './responseB4AListBrand';
export * from './responseB4AListBrandProductVariantMovementTags';
export * from './responseB4AListCampaign';
export * from './responseB4AListCampaignEligibleCustomerDTO';
export * from './responseB4AListCampaignExecutionCustomer';
export * from './responseB4AListCampaignGift';
export * from './responseB4AListCampaignSubscriptionType';
export * from './responseB4AListCanceledWithPendingBilling';
export * from './responseB4AListCardDifference';
export * from './responseB4AListCardOtherSubscription';
export * from './responseB4AListCategory';
export * from './responseB4AListCategorySummaryDTO';
export * from './responseB4AListComposition';
export * from './responseB4AListCompositionBeautyProfileCheck';
export * from './responseB4AListCompositionDetails';
export * from './responseB4AListCompositionEditionStatusTotal';
export * from './responseB4AListCompositionProductVariant';
export * from './responseB4AListCompositionProductVariantSummary';
export * from './responseB4AListCompositionProduction';
export * from './responseB4AListCompositionSubscriberEditionStatusCounter';
export * from './responseB4AListCouponAcquisitionSummary';
export * from './responseB4AListCouponDTO';
export * from './responseB4AListCouponEmailRestriction';
export * from './responseB4AListCouponEmailRestrictionDetail';
export * from './responseB4AListCouponProductVariantGroupRestriction';
export * from './responseB4AListCouponProductVariantSubscriptionTypeRestriction';
export * from './responseB4AListCouponProductVariantSummary';
export * from './responseB4AListCouponSubscriptionTypeRestriction';
export * from './responseB4AListCouponUsageSummary';
export * from './responseB4AListCouponUsageType';
export * from './responseB4AListCouponUsageTypeByCouponName';
export * from './responseB4AListCourseLikeDetail';
export * from './responseB4AListCourseModule';
export * from './responseB4AListCourseModuleContent';
export * from './responseB4AListCreatedTransactionBenefit';
export * from './responseB4AListCreditCardRecurrenceStatus';
export * from './responseB4AListCreditCardSummary';
export * from './responseB4AListCustomQueryGroup';
export * from './responseB4AListDailyOrderCountByMonth';
export * from './responseB4AListDeadlockedBenefit';
export * from './responseB4AListDivergentBfluencerStatus';
export * from './responseB4AListDivergentBfluencerStatusCheck';
export * from './responseB4AListDivergentSubscriberBenefit';
export * from './responseB4AListDontReceiveGift';
export * from './responseB4AListDoubleCommission';
export * from './responseB4AListDropdownFilter';
export * from './responseB4AListDuplicatedEdition';
export * from './responseB4AListDuplicatedReward';
export * from './responseB4AListEdition';
export * from './responseB4AListEditionBadgeScoreDetails';
export * from './responseB4AListEditionCustomizationIcons';
export * from './responseB4AListEditionScoreDetails';
export * from './responseB4AListEditionScoreLogAcc';
export * from './responseB4AListEmailTemplate';
export * from './responseB4AListExpiredGlampoints';
export * from './responseB4AListFailedPaymentData';
export * from './responseB4AListFeedbackAnswer';
export * from './responseB4AListFeedbackAnswerDetail';
export * from './responseB4AListFeedbackForm';
export * from './responseB4AListFeedbackGroupOption';
export * from './responseB4AListFeedbackLLMResponse';
export * from './responseB4AListFeedbackOption';
export * from './responseB4AListFeedbackQuestion';
export * from './responseB4AListGCPDatabaseUserResponse';
export * from './responseB4AListGateway';
export * from './responseB4AListGiftCycleResponseDTO';
export * from './responseB4AListIncorrectAnnualMonthInstallment';
export * from './responseB4AListIncorrectEndEdition';
export * from './responseB4AListIncorrectPendingBilling';
export * from './responseB4AListIncorrectSubscriberStatus';
export * from './responseB4AListInfluencerCouponDetailView';
export * from './responseB4AListInfluencerStatus';
export * from './responseB4AListInfluencerTransactionType';
export * from './responseB4AListInfolessAddress';
export * from './responseB4AListInstagramUser';
export * from './responseB4AListIntegrationTokenDomainView';
export * from './responseB4AListIntegrationTokenRole';
export * from './responseB4AListIntegrityHistoryDTO';
export * from './responseB4AListInvoiceControl';
export * from './responseB4AListItauCobrancaRecorrenteResponse';
export * from './responseB4AListItauCobrancaResponse';
export * from './responseB4AListItauRecorrenciaResponse';
export * from './responseB4AListLiveAccessDetail';
export * from './responseB4AListLiveContent';
export * from './responseB4AListLiveLikeDetail';
export * from './responseB4AListLoggerUpdatedServiceCompanyRangeDTO';
export * from './responseB4AListLoggerUpdatedShippingCompanyRangeDTO';
export * from './responseB4AListLong';
export * from './responseB4AListMapStringObject';
export * from './responseB4AListMuchPendingBillings';
export * from './responseB4AListNotAttemptedPayment';
export * from './responseB4AListNotPendingRecurrence';
export * from './responseB4AListNotificationTrend';
export * from './responseB4AListNullAddress';
export * from './responseB4AListOrderMovementStatusDescription';
export * from './responseB4AListOrders';
export * from './responseB4AListOrdersItemsDetailDTO';
export * from './responseB4AListPagarMeCustomerResponse';
export * from './responseB4AListPaidBillingsSameMonth';
export * from './responseB4AListPaymentDivergentPlan';
export * from './responseB4AListPaymentExpirationConfig';
export * from './responseB4AListPaymentExpirationConfigLogDetail';
export * from './responseB4AListPaymentResponseMessageType';
export * from './responseB4AListPaymentRound';
export * from './responseB4AListPaymentRoundCreditCardPayment';
export * from './responseB4AListPaymentRoundSummary';
export * from './responseB4AListPaymentSameMonth';
export * from './responseB4AListPaymentWithoutBilling';
export * from './responseB4AListPendingWithoutRecurrence';
export * from './responseB4AListPeriodType';
export * from './responseB4AListPersonActionDetailed';
export * from './responseB4AListPersonAttributeLogDetail';
export * from './responseB4AListPersonFeedbackGroupDetail';
export * from './responseB4AListPersonRelationInfo';
export * from './responseB4AListPersonReward';
export * from './responseB4AListPersonType';
export * from './responseB4AListPixPaymentReport';
export * from './responseB4AListPixRecurrenceDetail';
export * from './responseB4AListProductFinality';
export * from './responseB4AListProductFinalityItem';
export * from './responseB4AListProductImage';
export * from './responseB4AListProductIntegrationFailure';
export * from './responseB4AListProductReviewId';
export * from './responseB4AListProductSummary';
export * from './responseB4AListProductVariant';
export * from './responseB4AListProductVariantBrand';
export * from './responseB4AListProductVariantCategoryDetailResponse';
export * from './responseB4AListProductVariantDTO';
export * from './responseB4AListProductVariantFidelizationSummary';
export * from './responseB4AListProductVariantReserved';
export * from './responseB4AListProductVariantSummary';
export * from './responseB4AListProductVariantTotals';
export * from './responseB4AListProductVariantTotalsByDate';
export * from './responseB4AListRecurrenceIsNull';
export * from './responseB4AListRenewalReprocess';
export * from './responseB4AListRenewalWrongPrice';
export * from './responseB4AListReward';
export * from './responseB4AListRewardType';
export * from './responseB4AListSendFailure';
export * from './responseB4AListServiceCompanyRangeDTO';
export * from './responseB4AListShippingCompany';
export * from './responseB4AListShippingCompanyAvailable';
export * from './responseB4AListShippingCompanyDTO';
export * from './responseB4AListShippingCompanyRangeDTO';
export * from './responseB4AListShippingOrder';
export * from './responseB4AListShippingOrderAddressChange';
export * from './responseB4AListShippingOrderAlertDetail';
export * from './responseB4AListShippingOrderCompanyLogDetail';
export * from './responseB4AListShippingOrderItem';
export * from './responseB4AListShippingOrderItemDetail';
export * from './responseB4AListShippingOrderItemLogDetail';
export * from './responseB4AListShippingOrderRequestItem';
export * from './responseB4AListShippingOrderRequestItemPendingStock';
export * from './responseB4AListShippingOrderStatus';
export * from './responseB4AListShippingService';
export * from './responseB4AListShippingTrackingStatusDTO';
export * from './responseB4AListShopOrderRefundDetail';
export * from './responseB4AListSkeeloBenefitsByMonthYearDTO';
export * from './responseB4AListSkeeloChartDataDTO';
export * from './responseB4AListSkeeloPersonBenefitReportDTO';
export * from './responseB4AListSocialMedia';
export * from './responseB4AListSocialMediaUserDetail';
export * from './responseB4AListSocialMediaUserLogDetail';
export * from './responseB4AListSpecificCarrierPriorityShipmentsDTO';
export * from './responseB4AListStateDTO';
export * from './responseB4AListSubscriberAcquisition';
export * from './responseB4AListSubscriberAddressChangeTable';
export * from './responseB4AListSubscriberBillingStatus';
export * from './responseB4AListSubscriberCancellationDetail';
export * from './responseB4AListSubscriberCancellationReason';
export * from './responseB4AListSubscriberControlDetail';
export * from './responseB4AListSubscriberControlGroupByDate';
export * from './responseB4AListSubscriberControlGroupBySubscriptionType';
export * from './responseB4AListSubscriberControlGroupCounterByGroup';
export * from './responseB4AListSubscriberControlGroupCounterOldest';
export * from './responseB4AListSubscriberControlGroupDetail';
export * from './responseB4AListSubscriberControlRegretDetail';
export * from './responseB4AListSubscriberCoupon';
export * from './responseB4AListSubscriberCouponDetail';
export * from './responseB4AListSubscriberEditionCompositionSummary';
export * from './responseB4AListSubscriberEditionShippingDetail';
export * from './responseB4AListSubscriberEditionShippingDetails';
export * from './responseB4AListSubscriberEditionStatus';
export * from './responseB4AListSubscriberInfo';
export * from './responseB4AListSubscriberPaymentDetail';
export * from './responseB4AListSubscriberPaymentReward';
export * from './responseB4AListSubscriberPaymentStepErrorSummary';
export * from './responseB4AListSubscriberProblemGroupDetail';
export * from './responseB4AListSubscriberProblemGroupResolutionsByDate';
export * from './responseB4AListSubscriberProblemGroupResolutionsByDateAndUsername';
export * from './responseB4AListSubscriberReactivation';
export * from './responseB4AListSubscriberRefund';
export * from './responseB4AListSubscriberRenewalInfo';
export * from './responseB4AListSubscriberStatus';
export * from './responseB4AListSubscriberUpgradeDowngrade';
export * from './responseB4AListSubscription';
export * from './responseB4AListSubscriptionAndSubscriptionTypeDto';
export * from './responseB4AListSubscriptionType';
export * from './responseB4AListSubscriptionTypeGatewayPriority';
export * from './responseB4AListSubscriptionTypePaymentPriority';
export * from './responseB4AListSubscriptionTypePrice';
export * from './responseB4AListSubscriptionTypeTaxDto';
export * from './responseB4AListSubscriptionsPerHour';
export * from './responseB4AListSubscriptionsPerHourRealtime';
export * from './responseB4AListTransactionStatus';
export * from './responseB4AListTwoSubscriptionsInOneCpf';
export * from './responseB4AListUncomputedBfluenceTransaction';
export * from './responseB4AListUncomputedBfluenceTransactionCheck';
export * from './responseB4AListUnregisteredSubCommission';
export * from './responseB4AListUserRoleViewResponse';
export * from './responseB4AListVoucherSubscriberBilling';
export * from './responseB4AListWeightRangeServiceCompanyRange';
export * from './responseB4AListWeightRangeShippingCompanyRange';
export * from './responseB4AListWrongRecurrenceDate';
export * from './responseB4ALive';
export * from './responseB4AMapStringObject';
export * from './responseB4AObject';
export * from './responseB4APageAcquisitionAndReactivationReprocess';
export * from './responseB4APageActiveFormAdmin';
export * from './responseB4APageActiveSubscriptionNew';
export * from './responseB4APageAllSubscriptionTypes';
export * from './responseB4APageArticleDetail';
export * from './responseB4APageBadge';
export * from './responseB4APageBenefitWithoutCard';
export * from './responseB4APageBenefitWithoutCoupon';
export * from './responseB4APageBenefitWithoutNextMonth';
export * from './responseB4APageBrandSummaryView';
export * from './responseB4APageCanceledWithPendingBilling';
export * from './responseB4APageCardDifference';
export * from './responseB4APageCardOtherSubscription';
export * from './responseB4APageCompositionDetails';
export * from './responseB4APageCompositionProductionSummary';
export * from './responseB4APageCouponPriceChangeDetail';
export * from './responseB4APageCouponSummary';
export * from './responseB4APageCourseDetail';
export * from './responseB4APageCreatedTransactionBenefit';
export * from './responseB4APageCreditCardPaymentSummary';
export * from './responseB4APageCreditCardRecurrenceLogDetail';
export * from './responseB4APageCustomQueryDetail';
export * from './responseB4APageDeadlockedBenefit';
export * from './responseB4APageDivergentBfluencerStatusCheck';
export * from './responseB4APageDivergentSubscriberBenefit';
export * from './responseB4APageDontReceiveGift';
export * from './responseB4APageDoubleCommission';
export * from './responseB4APageDuplicatedReward';
export * from './responseB4APageEditionCustomization';
export * from './responseB4APageEmailNotificationBasicDetail';
export * from './responseB4APageEmailNotificationDetail';
export * from './responseB4APageEmailTemplate';
export * from './responseB4APageExpiredGlampoints';
export * from './responseB4APageFailedPaymentData';
export * from './responseB4APageFeedbackAnswerDetail';
export * from './responseB4APageFeedbackFormDetail';
export * from './responseB4APageFeedbackGroupDetail';
export * from './responseB4APageIncorrectAnnualMonthInstallment';
export * from './responseB4APageIncorrectEndEdition';
export * from './responseB4APageIncorrectPendingBilling';
export * from './responseB4APageIncorrectSubscriberStatus';
export * from './responseB4APageInfolessAddress';
export * from './responseB4APageIntegrationTokenView';
export * from './responseB4APageLiveDetail';
export * from './responseB4APageMuchPendingBillings';
export * from './responseB4APageNotAttemptedPayment';
export * from './responseB4APageNotPendingRecurrence';
export * from './responseB4APageNullAddress';
export * from './responseB4APagePaidBillingsSameMonth';
export * from './responseB4APagePaymentErrorDetail';
export * from './responseB4APagePaymentResponseMessageDetail';
export * from './responseB4APagePaymentSameMonth';
export * from './responseB4APagePaymentWithoutBilling';
export * from './responseB4APagePendingWithoutRecurrence';
export * from './responseB4APagePersonDetail';
export * from './responseB4APagePersonLogTransaction';
export * from './responseB4APageProductFeedbackAdmin';
export * from './responseB4APageProductReviewDetailed';
export * from './responseB4APageProductSummary';
export * from './responseB4APageProductVariantCategoryDetail';
export * from './responseB4APageProductVariantShippingOrderDetail';
export * from './responseB4APageRecurrenceIsNull';
export * from './responseB4APageRenewalReprocess';
export * from './responseB4APageRenewalWrongPrice';
export * from './responseB4APageSQLSession';
export * from './responseB4APageShippingOrderDetail';
export * from './responseB4APageShippingOrderRequestDetail';
export * from './responseB4APageShopOrderRequest';
export * from './responseB4APageSubscriberCancellationDetail';
export * from './responseB4APageSubscriberCouponSummary';
export * from './responseB4APageSubscriberInfo';
export * from './responseB4APageSubscriberLogDetail';
export * from './responseB4APageSubscriberPaymentStepError';
export * from './responseB4APageSubscriberRefundSummary';
export * from './responseB4APageSubscriberRenewalRefund';
export * from './responseB4APageTwoSubscriptionsInOneCpf';
export * from './responseB4APageUncomputedBfluenceTransactionCheck';
export * from './responseB4APageUnregisteredSubCommission';
export * from './responseB4APageWrongRecurrenceDate';
export * from './responseB4APasswordResetResponse';
export * from './responseB4APaymentExpirationConfig';
export * from './responseB4APaymentResponseMessage';
export * from './responseB4APaymentResponseMessageType';
export * from './responseB4APaymentRoundListResponse';
export * from './responseB4APaymentRoundRunningStatus';
export * from './responseB4APaymentRoundSummary';
export * from './responseB4APendingExportOrder';
export * from './responseB4APerson';
export * from './responseB4APersonActionDetailed';
export * from './responseB4APersonDetail';
export * from './responseB4APersonReward';
export * from './responseB4AProduct';
export * from './responseB4AProductFinality';
export * from './responseB4AProductImage';
export * from './responseB4AProductSearchResponse';
export * from './responseB4AProductVariant';
export * from './responseB4AProductVariantAttribute';
export * from './responseB4AResendDashboardCount';
export * from './responseB4AResolutionResult';
export * from './responseB4AReward';
export * from './responseB4AShippingCompanyDTO';
export * from './responseB4AShippingOrder';
export * from './responseB4AShippingOrderItemDetail';
export * from './responseB4AShippingOrderItemsUpdateResponse';
export * from './responseB4AShippingOrderRequest';
export * from './responseB4AShippingOrderSubstitutionDetailResponse';
export * from './responseB4AShopContributionResponse';
export * from './responseB4AShopIncomeResponse';
export * from './responseB4ASkeeloDashboardMetricsDTO';
export * from './responseB4ASpecificCarrierPriorityShipmentsDTO';
export * from './responseB4AString';
export * from './responseB4ASubscriber';
export * from './responseB4ASubscriberBillingHistoryEdition';
export * from './responseB4ASubscriberEditionCompositionSummary';
export * from './responseB4ASubscriptionType';
export * from './responseB4ASubscriptionTypePrice';
export * from './responseB4ASubscriptionTypeTaxDto';
export * from './responseB4ASubscriptionsTotalResponse';
export * from './responseB4AURL';
export * from './responseB4AUserRoleViewResponse';
export * from './reward';
export * from './rewardCreateRequest';
export * from './rewardType';
export * from './sQLSession';
export * from './salepriceBatchBody';
export * from './searchProduct';
export * from './sendFailure';
export * from './serviceCompanyRangeDTO';
export * from './serviceTaxPriceDto';
export * from './shippingCompany';
export * from './shippingCompanyAvailable';
export * from './shippingCompanyDTO';
export * from './shippingCompanyRangeDTO';
export * from './shippingOrder';
export * from './shippingOrderAddressChange';
export * from './shippingOrderAddressUpdateRequest';
export * from './shippingOrderAlertDetail';
export * from './shippingOrderCompanyLogDetail';
export * from './shippingOrderDetail';
export * from './shippingOrderItem';
export * from './shippingOrderItemDetail';
export * from './shippingOrderItemLog';
export * from './shippingOrderItemLogDetail';
export * from './shippingOrderItemUpdateRequest';
export * from './shippingOrderItemsUpdateResponse';
export * from './shippingOrderRequest';
export * from './shippingOrderRequestDetail';
export * from './shippingOrderRequestItem';
export * from './shippingOrderRequestItemPendingStock';
export * from './shippingOrderResendCreateRequest';
export * from './shippingOrderStatus';
export * from './shippingOrderSubstitutionDetailResponse';
export * from './shippingOrderUpdateRequest';
export * from './shippingService';
export * from './shippingTrackingStatusDTO';
export * from './shopContributionResponse';
export * from './shopIncomeResponse';
export * from './shopOrderProductRefundRequest';
export * from './shopOrderRefundDetail';
export * from './shopOrderRefundRequest';
export * from './shopOrderRequest';
export * from './shopOrderRequestUpdate';
export * from './skeeloBenefitsByMonthYearDTO';
export * from './skeeloChartDataDTO';
export * from './skeeloDashboardMetricsDTO';
export * from './skeeloPersonBenefitReportDTO';
export * from './socialMedia';
export * from './socialMediaUserDetail';
export * from './socialMediaUserLogDetail';
export * from './sortObject';
export * from './specificCarrierPriorityShipmentsDTO';
export * from './specificCarrierPriorityShipmentsInputDTO';
export * from './stateDTO';
export * from './subscriber';
export * from './subscriberAcquisition';
export * from './subscriberAddressChangeTable';
export * from './subscriberBillingHistoryEdition';
export * from './subscriberBillingStatus';
export * from './subscriberCancellationDetail';
export * from './subscriberCancellationReason';
export * from './subscriberCancellationRequest';
export * from './subscriberControlDetail';
export * from './subscriberControlGroupByDate';
export * from './subscriberControlGroupBySubscriptionType';
export * from './subscriberControlGroupCounterByGroup';
export * from './subscriberControlGroupCounterOldest';
export * from './subscriberControlGroupDetail';
export * from './subscriberControlRegretDetail';
export * from './subscriberCoupon';
export * from './subscriberCouponDetail';
export * from './subscriberCouponSummary';
export * from './subscriberEditionCompositionSummary';
export * from './subscriberEditionShippingDetail';
export * from './subscriberEditionShippingDetails';
export * from './subscriberEditionStatus';
export * from './subscriberEditionStatusRequest';
export * from './subscriberInfo';
export * from './subscriberLogDetail';
export * from './subscriberPaymentDetail';
export * from './subscriberPaymentReward';
export * from './subscriberPaymentStepError';
export * from './subscriberPaymentStepErrorSummary';
export * from './subscriberProblemGroupDetail';
export * from './subscriberProblemGroupResolutionsByDate';
export * from './subscriberProblemGroupResolutionsByDateAndUsername';
export * from './subscriberReactivation';
export * from './subscriberRefund';
export * from './subscriberRefundRequest';
export * from './subscriberRefundSummary';
export * from './subscriberRenewalInfo';
export * from './subscriberRenewalRefund';
export * from './subscriberStatus';
export * from './subscriberStatusChangeRequest';
export * from './subscriberUpgradeDowngrade';
export * from './subscription';
export * from './subscriptionAndSubscriptionTypeDto';
export * from './subscriptionType';
export * from './subscriptionTypeDto';
export * from './subscriptionTypeGatewayPriority';
export * from './subscriptionTypePaymentPriority';
export * from './subscriptionTypePrice';
export * from './subscriptionTypeTaxDto';
export * from './subscriptionsPerHour';
export * from './subscriptionsPerHourRealtime';
export * from './subscriptionsTotalResponse';
export * from './taxPriceDto';
export * from './transactionStatus';
export * from './twoSubscriptionsInOneCpf';
export * from './uncomputedBfluenceTransaction';
export * from './uncomputedBfluenceTransactionCheck';
export * from './unregisteredSubCommission';
export * from './upgradeDowngradeDashboardRequest';
export * from './userCreateRequest';
export * from './userRoleRequest';
export * from './userRoleViewResponse';
export * from './userUpdateRequest';
export * from './voucherSubscriberBilling';
export * from './weightRangeServiceCompanyRange';
export * from './weightRangeShippingCompanyRange';
export * from './wrongRecurrenceDate';
